/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  LogFilter,
  LogFilter$Outbound,
  LogFilter$outboundSchema,
} from "./logfilter.js";

/**
 * Sort order
 */
export const Sort = {
  Asc: "asc",
  Desc: "desc",
} as const;
/**
 * Sort order
 */
export type Sort = ClosedEnum<typeof Sort>;

export const ListHooksTracesPayloadTypesToInclude = {
  Mcp: "mcp",
  Local: "local",
  Skill: "skill",
} as const;
export type ListHooksTracesPayloadTypesToInclude = ClosedEnum<
  typeof ListHooksTracesPayloadTypesToInclude
>;

/**
 * Payload for listing hook traces
 */
export type ListHooksTracesPayload = {
  /**
   * Cursor for pagination (trace_id)
   */
  cursor?: string | undefined;
  /**
   * Filter conditions for the search query
   */
  filters?: Array<LogFilter> | undefined;
  /**
   * Start time in ISO 8601 format (e.g., '2025-12-19T10:00:00Z')
   */
  from: Date;
  /**
   * Number of items to return (1-1000)
   */
  limit?: number | undefined;
  /**
   * Sort order
   */
  sort?: Sort | undefined;
  /**
   * End time in ISO 8601 format (e.g., '2025-12-19T11:00:00Z')
   */
  to: Date;
  /**
   * Hook types to include (mcp, local, skill). If empty or not provided, includes all types.
   */
  typesToInclude?: Array<ListHooksTracesPayloadTypesToInclude> | undefined;
};

/** @internal */
export const Sort$outboundSchema: z.ZodMiniEnum<typeof Sort> = z.enum(Sort);

/** @internal */
export const ListHooksTracesPayloadTypesToInclude$outboundSchema: z.ZodMiniEnum<
  typeof ListHooksTracesPayloadTypesToInclude
> = z.enum(ListHooksTracesPayloadTypesToInclude);

/** @internal */
export type ListHooksTracesPayload$Outbound = {
  cursor?: string | undefined;
  filters?: Array<LogFilter$Outbound> | undefined;
  from: string;
  limit: number;
  sort: string;
  to: string;
  types_to_include?: Array<string> | undefined;
};

/** @internal */
export const ListHooksTracesPayload$outboundSchema: z.ZodMiniType<
  ListHooksTracesPayload$Outbound,
  ListHooksTracesPayload
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    filters: z.optional(z.array(LogFilter$outboundSchema)),
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    limit: z._default(z.int(), 50),
    sort: z._default(Sort$outboundSchema, "desc"),
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
    typesToInclude: z.optional(
      z.array(ListHooksTracesPayloadTypesToInclude$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      typesToInclude: "types_to_include",
    });
  }),
);

export function listHooksTracesPayloadToJSON(
  listHooksTracesPayload: ListHooksTracesPayload,
): string {
  return JSON.stringify(
    ListHooksTracesPayload$outboundSchema.parse(listHooksTracesPayload),
  );
}
